import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_LOAN_SETTLEMENTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.EDIT_LOAN_SETTLEMENT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CLEAR_LOAN_SETTLEMENT:
      return [];
    default:
      return state;
  }
};
